import React, { useState, useRef, useEffect } from 'react'
import { FaceMesh, Results } from "@mediapipe/face_mesh"
import { Camera } from "@mediapipe/camera_utils"
import { drawConnectors, drawLandmarks } from "@mediapipe/drawing_utils";
import { FACEMESH_LEFT_EYEBROW, FACEMESH_FACE_OVAL, FACEMESH_LIPS, FACEMESH_RIGHT_EYEBROW, FACEMESH_LEFT_EYE, FACEMESH_RIGHT_EYE } from "@mediapipe/face_mesh";
import { orientationFeedback } from '../utils/face'
import { UploadImages } from './UploadImages';
import { SpinningCircle } from './SpinningCircle';
import { LoginOrContinue } from './LoginOrContinue';
import { CameraResult } from './CameraResult';
import { User } from '../types/User';
import { WizardAction, WizardState} from '../types/WigWizard';
import { ProductCustomizerState } from '../types/ProductCustomizer';


export function Measure({ setCameraVisible, state, dispatch, user, dispatchProductCustomizer,stateProductCustomizer}: { user: User, setCameraVisible: React.Dispatch<React.SetStateAction<boolean>>, state: WizardState, dispatch: React.Dispatch<WizardAction> ,dispatchProductCustomizer: Function,stateProductCustomizer: ProductCustomizerState}) {
  const selectors = {
    measureButton: '[data-start-measuring]',
    addToCartButton: '[data-add-to-cart-button]',
  }

  const sizingCopy = [
    'PLACE YOUR CARD ON YOUR FOREHEAD',
    'TURN YOUR HEAD RIGHT, PLACE YOUR CARD ON YOUR TEMPLE',
    'TURN YOUR HEAD LEFT, PLACE YOUR CARD ON YOUR TEMPLE',
    'LOOK STRAIGHT AT THE CAMERA, NO CARD, AND SMILE',
    '',
    // 'MEASURING YOUR CAP SIZE AND LACE TINT',
    "Our AI IS ANALYZING YOUR DATA",
  ]

  const canvasRef = useRef<HTMLCanvasElement>(null)
  const feedbackRef = useRef<HTMLParagraphElement>(null)
  const photoButtonRef = useRef<HTMLButtonElement>(null)
  const overlayRef = useRef<HTMLImageElement>(null)
  const videoRef = useRef<HTMLVideoElement>(null)
  const [showCanvas, setShowCanvas] = useState(true);
  const isNotSafariBrowser = !(navigator.userAgent.indexOf('Safari') > -1 && navigator.userAgent.indexOf('Chrome') <= -1)
  let camera: Camera, canvasElement: HTMLCanvasElement, canvasCtx: CanvasRenderingContext2D, currentImage: any
  const [errorMessage, setErrorMessage]=useState("")
  const [restartCamera, setRestartCamera]=useState(false)


  // These two weird useEffects is to restart the camera between screenshots. If no restart is made results.image.toDataURL() get no picture for some reason
  useEffect(() => {
    if (state.active >0 && state.active < 4) setShowCanvas(false)
  }, [state])
  useEffect(() => {
    setTimeout(() => {
      if (!showCanvas) setShowCanvas(true)
    }, 1000)
  }, [state, showCanvas])

  useEffect(() => {
    if (state.active === 4)
      UploadImages({ state, stateProductCustomizer,dispatch, setErrorMessage, redirectAfterLogin: !user.email ? location.href : '', email: user.email })
  }, [state])
  
  useEffect(()=>{
    let timeout: number;
     if(errorMessage!=""){
      timeout = setTimeout(() => {
        dispatch({type: "StartCamera"})
        setErrorMessage("")
        setRestartCamera(true)
      }, 5000)
    }
    return () => clearTimeout(timeout)
  },[errorMessage])



  useEffect(() => {
    let timeout: number;
    overlayRef.current.classList.remove('opacity-0')
    if (overlayRef.current) {
      if (state.active === 0)
        overlayRef.current.src = 'https://measure-overlay.s3.amazonaws.com/Measure_Step_1_New_Transparent.png'
      if (state.active === 1)
        overlayRef.current.src = 'https://measure-overlay.s3.amazonaws.com/Measure_Step_2_New_Transparent.png'
      if (state.active === 2)
        overlayRef.current.src = 'https://measure-overlay.s3.amazonaws.com/Measure_Step_3_New_Transparent.png'
      if (state.active === 3)
        overlayRef.current.src = 'https://measure-overlay.s3.amazonaws.com/Measure_Step_4_New_Transparent.png'
      timeout = setTimeout(() => {
        overlayRef.current.classList.add('opacity-0')
      }, 5000)
    }
    return () => clearTimeout(timeout)
  }, [state.active])

  function close() {
    setCameraVisible(false)
    // document.querySelector(selectors.measureButton).scrollIntoView({ behavior: "smooth" })
  }

  function onResults(results: Results) {
    canvasCtx.save();
    // @ts-ignore
    currentImage = results.image.toDataURL();

    if (photoButtonRef.current)
      photoButtonRef.current.disabled = false

    canvasRef.current.height = results.image.height
    canvasRef.current.width = results.image.width
    canvasCtx.clearRect(0, 0, canvasElement.width, canvasElement.height);
    canvasCtx.drawImage(
      results.image, 0, 0, canvasElement.width, canvasElement.height);
    if (results.multiFaceLandmarks) {
      for (const landmark of results.multiFaceLandmarks) {
        var feedback = orientationFeedback(landmark, state.active);
        var feedback_status = feedback[0];
        var feedback_text = feedback[1];

        feedbackRef.current.innerHTML = feedback_text;
        if (feedback_status) {
          feedbackRef.current.classList.add('text-lime-700')
          feedbackRef.current.classList.remove('text-rose-400')
        } else {
          feedbackRef.current.classList.add('text-rose-400')
          feedbackRef.current.classList.remove('text-lime-700')
        }

        if (isNotSafariBrowser) {
          drawLandmarks(canvasCtx, landmark, { color: '#C0C0C0FF', lineWidth: .5, radius: 2 });
          drawConnectors(
            canvasCtx, landmark, FACEMESH_RIGHT_EYE,
            { color: '#E0E0E070', lineWidth: 1 });
          drawConnectors(
            canvasCtx, landmark, FACEMESH_RIGHT_EYEBROW,
            { color: '#E0E0E070', lineWidth: 1 });
          drawConnectors(
            canvasCtx, landmark, FACEMESH_LEFT_EYE,
            { color: '#E0E0E070', lineWidth: 1 });
          drawConnectors(
            canvasCtx, landmark, FACEMESH_LEFT_EYEBROW,
            { color: '#E0E0E070', lineWidth: 1 });
          drawConnectors(
            canvasCtx, landmark, FACEMESH_FACE_OVAL,
            { color: '#E0E0E070', lineWidth: 1 });
          drawConnectors(
            canvasCtx, landmark, FACEMESH_LIPS,
            { color: '#E0E0E070', lineWidth: 1 });
        }
      }
    }
    canvasCtx.restore();
  }

  useEffect(() => {
    if (showCanvas) {
      canvasElement = canvasRef.current
      canvasCtx = canvasElement.getContext('2d');
      const faceMesh = new FaceMesh({
        locateFile: (file) => {
          return `https://cdn.jsdelivr.net/npm/@mediapipe/face_mesh/${file}`;
        },
      });
      faceMesh.setOptions({
        maxNumFaces: 1,
        minDetectionConfidence: 0.5,
        minTrackingConfidence: 0.5,
        selfieMode: true,
      });
      faceMesh.onResults(onResults);
      camera = new Camera(videoRef.current, {
        onFrame: async () => {
          try {
            await faceMesh.send({ image: videoRef.current });
          } catch (err) {
            console.log('error: ', err)
          }
        }
      });
      camera.start();
    }
  }, [showCanvas,errorMessage, restartCamera]);

  const handleSkip=()=>{
    dispatchProductCustomizer({
      type: "activeStep",
      value: stateProductCustomizer.activeStep+3
    })
    document.getElementById('CameraWizardClose').dispatchEvent(new Event('click')); 
  }

  return <div className="p-4 flex flex-col h-full">
    <div className="flex justify-between items-center flex-col">
      <svg id= "CameraWizardClose" onClick={() => close()} className="cursor-pointer self-end" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd"
          d="M0.509484 16.2458C0.314222 16.4411 0.314222 16.7577 0.509484 16.953C0.704746 17.1482 1.02133 17.1482 1.21659 16.953L8.99993 9.16961L16.7833 16.953C16.9785 17.1482 17.2951 17.1482 17.4904 16.953C17.6856 16.7577 17.6856 16.4411 17.4904 16.2458L9.70704 8.4625L16.7833 1.38627C16.9785 1.19101 16.9785 0.874424 16.7833 0.679162C16.588 0.4839 16.2714 0.4839 16.0762 0.679162L8.99993 7.7554L1.9237 0.679163C1.72844 0.483901 1.41185 0.483901 1.21659 0.679163C1.02133 0.874425 1.02133 1.19101 1.21659 1.38627L8.29283 8.4625L0.509484 16.2458Z"
          fill="black" />
      </svg>

      {state.active < 6 &&
        <h2 className="text-lg md:text-xl text-center leading-none">{sizingCopy[state.active]}</h2>
      }
      {state.active === 5 &&
        <p className="font-semibold text-base md:text-lg leading-none text-center whitespace-nowrap mt-3 mb-2.5">This can take a few seconds...</p>
      }

    </div>
    <div className={state.active < 4 ? '' : 'hidden'}>
      <p ref={feedbackRef} className="font-semibold text-base md:text-lg leading-none text-center uppercase whitespace-nowrap mt-3 mb-2.5"></p>
      <div className="flex w-full overflow-hidden justify-center items-center h-[60vh] relative" >
        {showCanvas &&
          <canvas id="output_canvas" ref={canvasRef} />
        }
        <img ref={overlayRef} className="absolute transition-opacity duration-500 object-cover" />
      </div>
      {showCanvas &&
        <video crossorigin="anonymous" playsinline="true" muted ref={videoRef} className="hidden"></video>
      }
    </div>
    {state.active === 5 &&
      <div  style="display:flex; flex-direction:column; justify-content:space-around" className="w-full h-full items-center flex-[1_0_100%]">
        <SpinningCircle />
        <p className={"text-red"}>{errorMessage}</p>

      </div>
    }

    <div className="flex flex-col justify-between h-full">
      <div>
        {state.active < 4 &&
          <button ref={photoButtonRef} id="captureButton" disabled className="bg-black text-white py-4 px-2 text-btn-m md:text-btn-d border-2 w-full md:max-w-[400px] md:block md:mx-auto my-2 disabled:bg-white disabled:border-2 disabled:border-black disabled:text-black uppercase" onClick={() => {dispatch({ type: 'Photo', value: currentImage }); photoButtonRef.current.disabled = true; }}>Capture</button>
        }

        {state.active > 5 &&
          <CameraResult user={user} continueFn={() => {

            setCameraVisible(false)
            document.querySelector(selectors.addToCartButton).scrollIntoView({ behavior: "smooth" })
          }} state={state} stateProductCustomizer={stateProductCustomizer} dispatchProductCustomizer={dispatchProductCustomizer}/>
        }

        {state.active < 4 &&
          <div className="flex flex-row justify-center gap-2.5 h-20">
            <img className="w-[50px] h-[50px] object-cover" src={state.steps[0].img} />
            <img className="w-[50px] h-[50px] object-cover" src={state.steps[1].img} />
            <img className="w-[50px] h-[50px] object-cover" src={state.steps[2].img} />
            <img className="w-[50px] h-[50px] object-cover" src={state.steps[3].img} />
          </div>
        }
      </div>
      <div>
      {state.active===0 && restartCamera && <p id="errorMessageDisplay" className={"text-red text-center"}>THERE WAS AN ISSUE WHILE PROCESSING YOUR PHOTOS, PLEASE RETAKE THEM</p>}
      </div>
      {state.active < 4 &&
         <button  onClick={handleSkip} className="text-sm underline underline-offset-4 font-medium mt-[0.75rem]">Having trouble taking photos? Click here to skip photos, you can always take them later</button>
      }
    </div>
  </div>
}

